define("shared/utils/formatters/ig-hashtag-from-dynamo", ["exports", "@ember/utils"], function (_exports, _utils) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/utils"eaimeta@70e063a35619d71f

  /**
   * Formats a raw dynamo hashtag response
   *
   * @method createIgHashtagFromDynamo
   * @param {RawDynamoHashtag} obj Raw dynamo hashtag object
   * @param {String} hashtagName Hashtag name
   * @param {Array<IgPost>} fetchedMedia List of igPosts for given hashtag
   *
   * @returns {FormattedDynamoHashtag} Returns a formatted hashtag object
   */
  function createIgHashtagFromDynamo(obj, hashtagName, fetchedMedia) {
    const attrs = {};
    attrs.name = hashtagName;
    attrs.createdTime = Number(obj.created_time);

    if (!(0, _utils.isNone)(obj.comment_count)) {
      attrs.commentCount = Number(obj.comment_count);
    }

    if (!(0, _utils.isNone)(obj.engagement)) {
      attrs.engagement = Number(obj.engagement);
    } else if (!(0, _utils.isNone)(obj.carousel_album_engagement)) {
      attrs.engagement = Number(obj.carousel_album_engagement);
    }

    if (!(0, _utils.isNone)(obj.impressions)) {
      attrs.impressions = Number(obj.impressions);
    } else if (!(0, _utils.isNone)(obj.carousel_album_impressions)) {
      attrs.impressions = Number(obj.carousel_album_impressions);
    }

    if (!(0, _utils.isNone)(obj.like_count)) {
      attrs.likeCount = Number(obj.like_count);
    }

    attrs.media = obj.media.map(item => fetchedMedia.find(fetchedItem => fetchedItem.id === item.id));
    attrs.latestUsed = Math.max(...attrs.media.map(item => item.createdTime));

    if (!(0, _utils.isNone)(obj.num_posts)) {
      attrs.numPosts = Number(obj.num_posts);
    }

    if (!(0, _utils.isNone)(obj.reach)) {
      attrs.reach = Number(obj.reach);
    } else if (!(0, _utils.isNone)(obj.carousel_album_reach)) {
      attrs.reach = Number(obj.carousel_album_reach);
    }

    if (!(0, _utils.isNone)(obj.saved)) {
      attrs.savedCount = Number(obj.saved);
    } else if (!(0, _utils.isNone)(obj.carousel_album_saved)) {
      attrs.savedCount = Number(obj.carousel_album_saved);
    }

    if (!(0, _utils.isNone)(obj.video_views)) {
      attrs.views = Number(obj.video_views);
    } else if (!(0, _utils.isNone)(obj.carousel_album_video_views)) {
      attrs.views = Number(obj.carousel_album_video_views);
    }

    return attrs;
  }

  var _default = createIgHashtagFromDynamo;
  _exports.default = _default;
});